
<script setup>
import { Refresh } from '@element-plus/icons-vue';
</script>

<template>
  <el-button :icon="Refresh" circle @click="reload"></el-button>
</template>

<script>
export default {
  name: 'RefreshButton',
  methods: {
    reload() {
      this.$store.dispatch('game/fetchGameList', true);
    },
  },
};
</script>

<style scoped>

</style>
